import { ascending } from 'd3-array';

export interface Country {
  country: string;
  alpha2: string;
  alpha3: string;
  num3: string;
}

export const isoCountries: Country[] = [
  {
    alpha2: 'AD',
    alpha3: 'AND',
    country: 'Andorra',
    num3: '020',
  },
  {
    alpha2: 'AE',
    alpha3: 'ARE',
    country: 'United Arab Emirates',
    num3: '784',
  },
  {
    alpha2: 'AF',
    alpha3: 'AFG',
    country: 'Afghanistan',
    num3: '004',
  },
  {
    alpha2: 'AG',
    alpha3: 'ATG',
    country: 'Antigua and Barbuda',
    num3: '028',
  },
  {
    alpha2: 'AI',
    alpha3: 'AIA',
    country: 'Anguilla',
    num3: '660',
  },
  {
    alpha2: 'AL',
    alpha3: 'ALB',
    country: 'Albania',
    num3: '008',
  },
  {
    alpha2: 'AM',
    alpha3: 'ARM',
    country: 'Armenia',
    num3: '051',
  },
  {
    alpha2: 'AO',
    alpha3: 'AGO',
    country: 'Angola',
    num3: '024',
  },
  {
    alpha2: 'AQ',
    alpha3: 'ATA',
    country: 'Antarctica',
    num3: '010',
  },
  {
    alpha2: 'AR',
    alpha3: 'ARG',
    country: 'Argentina',
    num3: '032',
  },
  {
    alpha2: 'AS',
    alpha3: 'ASM',
    country: 'American Samoa',
    num3: '016',
  },
  {
    alpha2: 'AT',
    alpha3: 'AUT',
    country: 'Austria',
    num3: '040',
  },
  {
    alpha2: 'AU',
    alpha3: 'AUS',
    country: 'Australia',
    num3: '036',
  },
  {
    alpha2: 'AW',
    alpha3: 'ABW',
    country: 'Aruba',
    num3: '533',
  },
  {
    alpha2: 'AX',
    alpha3: 'ALA',
    country: 'Åland Islands',
    num3: '248',
  },
  {
    alpha2: 'AZ',
    alpha3: 'AZE',
    country: 'Azerbaijan',
    num3: '031',
  },
  {
    alpha2: 'BA',
    alpha3: 'BIH',
    country: 'Bosnia and Herzegovina',
    num3: '070',
  },
  {
    alpha2: 'BB',
    alpha3: 'BRB',
    country: 'Barbados',
    num3: '052',
  },
  {
    alpha2: 'BD',
    alpha3: 'BGD',
    country: 'Bangladesh',
    num3: '050',
  },
  {
    alpha2: 'BE',
    alpha3: 'BEL',
    country: 'Belgium',
    num3: '056',
  },
  {
    alpha2: 'BF',
    alpha3: 'BFA',
    country: 'Burkina Faso',
    num3: '854',
  },
  {
    alpha2: 'BG',
    alpha3: 'BGR',
    country: 'Bulgaria',
    num3: '100',
  },
  {
    alpha2: 'BH',
    alpha3: 'BHR',
    country: 'Bahrain',
    num3: '048',
  },
  {
    alpha2: 'BI',
    alpha3: 'BDI',
    country: 'Burundi',
    num3: '108',
  },
  {
    alpha2: 'BJ',
    alpha3: 'BEN',
    country: 'Benin',
    num3: '204',
  },
  {
    alpha2: 'BL',
    alpha3: 'BLM',
    country: 'Saint Barthélemy',
    num3: '652',
  },
  {
    alpha2: 'BM',
    alpha3: 'BMU',
    country: 'Bermuda',
    num3: '060',
  },
  {
    alpha2: 'BN',
    alpha3: 'BRN',
    country: 'Brunei Darussalam',
    num3: '096',
  },
  {
    alpha2: 'BO',
    alpha3: 'BOL',
    country: 'Bolivia',
    num3: '068',
  },
  {
    alpha2: 'BQ',
    alpha3: 'BES',
    country: 'Bonaire, Sint Eustatius and Saba',
    num3: '535',
  },
  {
    alpha2: 'BR',
    alpha3: 'BRA',
    country: 'Brazil',
    num3: '076',
  },
  {
    alpha2: 'BS',
    alpha3: 'BHS',
    country: 'Bahamas',
    num3: '044',
  },
  {
    alpha2: 'BT',
    alpha3: 'BTN',
    country: 'Bhutan',
    num3: '064',
  },
  {
    alpha2: 'BV',
    alpha3: 'BVT',
    country: 'Bouvet Island',
    num3: '074',
  },
  {
    alpha2: 'BW',
    alpha3: 'BWA',
    country: 'Botswana',
    num3: '072',
  },
  {
    alpha2: 'BY',
    alpha3: 'BLR',
    country: 'Belarus',
    num3: '112',
  },
  {
    alpha2: 'BZ',
    alpha3: 'BLZ',
    country: 'Belize',
    num3: '084',
  },
  {
    alpha2: 'CA',
    alpha3: 'CAN',
    country: 'Canada',
    num3: '124',
  },
  {
    alpha2: 'CC',
    alpha3: 'CCK',
    country: 'Cocos Islands',
    num3: '166',
  },
  {
    alpha2: 'CD',
    alpha3: 'COD',
    country: 'Congo',
    num3: '180',
  },
  {
    alpha2: 'CF',
    alpha3: 'CAF',
    country: 'Central African Republic',
    num3: '140',
  },
  {
    alpha2: 'CG',
    alpha3: 'COG',
    country: 'Congo',
    num3: '178',
  },
  {
    alpha2: 'CH',
    alpha3: 'CHE',
    country: 'Switzerland',
    num3: '756',
  },
  {
    alpha2: 'CI',
    alpha3: 'CIV',
    country: "Côte d'Ivoire",
    num3: '384',
  },
  {
    alpha2: 'CK',
    alpha3: 'COK',
    country: 'Cook Islands',
    num3: '184',
  },
  {
    alpha2: 'CL',
    alpha3: 'CHL',
    country: 'Chile',
    num3: '152',
  },
  {
    alpha2: 'CM',
    alpha3: 'CMR',
    country: 'Cameroon',
    num3: '120',
  },
  {
    alpha2: 'CN',
    alpha3: 'CHN',
    country: 'China',
    num3: '156',
  },
  {
    alpha2: 'CO',
    alpha3: 'COL',
    country: 'Colombia',
    num3: '170',
  },
  {
    alpha2: 'CR',
    alpha3: 'CRI',
    country: 'Costa Rica',
    num3: '188',
  },
  {
    alpha2: 'CU',
    alpha3: 'CUB',
    country: 'Cuba',
    num3: '192',
  },
  {
    alpha2: 'CV',
    alpha3: 'CPV',
    country: 'Cabo Verde',
    num3: '132',
  },
  {
    alpha2: 'CW',
    alpha3: 'CUW',
    country: 'Curaçao',
    num3: '531',
  },
  {
    alpha2: 'CX',
    alpha3: 'CXR',
    country: 'Christmas Island',
    num3: '162',
  },
  {
    alpha2: 'CY',
    alpha3: 'CYP',
    country: 'Cyprus',
    num3: '196',
  },
  {
    alpha2: 'CZ',
    alpha3: 'CZE',
    country: 'Czech Republic',
    num3: '203',
  },
  {
    alpha2: 'DE',
    alpha3: 'DEU',
    country: 'Germany',
    num3: '276',
  },
  {
    alpha2: 'DJ',
    alpha3: 'DJI',
    country: 'Djibouti',
    num3: '262',
  },
  {
    alpha2: 'DK',
    alpha3: 'DNK',
    country: 'Denmark',
    num3: '208',
  },
  {
    alpha2: 'DM',
    alpha3: 'DMA',
    country: 'Dominica',
    num3: '212',
  },
  {
    alpha2: 'DO',
    alpha3: 'DOM',
    country: 'Dominican Republic',
    num3: '214',
  },
  {
    alpha2: 'DZ',
    alpha3: 'DZA',
    country: 'Algeria',
    num3: '012',
  },
  {
    alpha2: 'EC',
    alpha3: 'ECU',
    country: 'Ecuador',
    num3: '218',
  },
  {
    alpha2: 'EE',
    alpha3: 'EST',
    country: 'Estonia',
    num3: '233',
  },
  {
    alpha2: 'EG',
    alpha3: 'EGY',
    country: 'Egypt',
    num3: '818',
  },
  {
    alpha2: 'EH',
    alpha3: 'ESH',
    country: 'Western Sahara',
    num3: '732',
  },
  {
    alpha2: 'ER',
    alpha3: 'ERI',
    country: 'Eritrea',
    num3: '232',
  },
  {
    alpha2: 'ES',
    alpha3: 'ESP',
    country: 'Spain',
    num3: '724',
  },
  {
    alpha2: 'ET',
    alpha3: 'ETH',
    country: 'Ethiopia',
    num3: '231',
  },
  {
    alpha2: 'FI',
    alpha3: 'FIN',
    country: 'Finland',
    num3: '246',
  },
  {
    alpha2: 'FJ',
    alpha3: 'FJI',
    country: 'Fiji',
    num3: '242',
  },
  {
    alpha2: 'FK',
    alpha3: 'FLK',
    country: 'Falkland Islands',
    num3: '238',
  },
  {
    alpha2: 'FM',
    alpha3: 'FSM',
    country: 'Federated States of Micronesia',
    num3: '583',
  },
  {
    alpha2: 'FO',
    alpha3: 'FRO',
    country: 'Faroe Islands',
    num3: '234',
  },
  {
    alpha2: 'FR',
    alpha3: 'FRA',
    country: 'France',
    num3: '250',
  },
  {
    alpha2: 'GA',
    alpha3: 'GAB',
    country: 'Gabon',
    num3: '266',
  },
  {
    alpha2: 'GB',
    alpha3: 'GBR',
    country: 'United Kingdom of Great Britain and Northern Ireland',
    num3: '826',
  },
  {
    alpha2: 'GD',
    alpha3: 'GRD',
    country: 'Grenada',
    num3: '308',
  },
  {
    alpha2: 'GE',
    alpha3: 'GEO',
    country: 'Georgia',
    num3: '268',
  },
  {
    alpha2: 'GF',
    alpha3: 'GUF',
    country: 'French Guiana',
    num3: '254',
  },
  {
    alpha2: 'GG',
    alpha3: 'GGY',
    country: 'Guernsey',
    num3: '831',
  },
  {
    alpha2: 'GH',
    alpha3: 'GHA',
    country: 'Ghana',
    num3: '288',
  },
  {
    alpha2: 'GI',
    alpha3: 'GIB',
    country: 'Gibraltar',
    num3: '292',
  },
  {
    alpha2: 'GL',
    alpha3: 'GRL',
    country: 'Greenland',
    num3: '304',
  },
  {
    alpha2: 'GM',
    alpha3: 'GMB',
    country: 'Gambia',
    num3: '270',
  },
  {
    alpha2: 'GN',
    alpha3: 'GIN',
    country: 'Guinea',
    num3: '324',
  },
  {
    alpha2: 'GP',
    alpha3: 'GLP',
    country: 'Guadeloupe',
    num3: '312',
  },
  {
    alpha2: 'GQ',
    alpha3: 'GNQ',
    country: 'Equatorial Guinea',
    num3: '226',
  },
  {
    alpha2: 'GR',
    alpha3: 'GRC',
    country: 'Greece',
    num3: '300',
  },
  {
    alpha2: 'GS',
    alpha3: 'SGS',
    country: 'South Georgia and the South Sandwich Islands',
    num3: '239',
  },
  {
    alpha2: 'GT',
    alpha3: 'GTM',
    country: 'Guatemala',
    num3: '320',
  },
  {
    alpha2: 'GU',
    alpha3: 'GUM',
    country: 'Guam',
    num3: '316',
  },
  {
    alpha2: 'GW',
    alpha3: 'GNB',
    country: 'Guinea-Bissau',
    num3: '624',
  },
  {
    alpha2: 'GY',
    alpha3: 'GUY',
    country: 'Guyana',
    num3: '328',
  },
  {
    alpha2: 'HK',
    alpha3: 'HKG',
    country: 'Hong Kong',
    num3: '344',
  },
  {
    alpha2: 'HM',
    alpha3: 'HMD',
    country: 'Heard Island and McDonald Islands',
    num3: '334',
  },
  {
    alpha2: 'HN',
    alpha3: 'HND',
    country: 'Honduras',
    num3: '340',
  },
  {
    alpha2: 'HR',
    alpha3: 'HRV',
    country: 'Croatia',
    num3: '191',
  },
  {
    alpha2: 'HT',
    alpha3: 'HTI',
    country: 'Haiti',
    num3: '332',
  },
  {
    alpha2: 'HU',
    alpha3: 'HUN',
    country: 'Hungary',
    num3: '348',
  },
  {
    alpha2: 'ID',
    alpha3: 'IDN',
    country: 'Indonesia',
    num3: '360',
  },
  {
    alpha2: 'IE',
    alpha3: 'IRL',
    country: 'Ireland',
    num3: '372',
  },
  {
    alpha2: 'IL',
    alpha3: 'ISR',
    country: 'Israel',
    num3: '376',
  },
  {
    alpha2: 'IM',
    alpha3: 'IMN',
    country: 'Isle of Man',
    num3: '833',
  },
  {
    alpha2: 'IN',
    alpha3: 'IND',
    country: 'India',
    num3: '356',
  },
  {
    alpha2: 'IO',
    alpha3: 'IOT',
    country: 'British Indian Ocean Territory',
    num3: '086',
  },
  {
    alpha2: 'IQ',
    alpha3: 'IRQ',
    country: 'Iraq',
    num3: '368',
  },
  {
    alpha2: 'IR',
    alpha3: 'IRN',
    country: 'Islamic Republic of Iran',
    num3: '364',
  },
  {
    alpha2: 'IS',
    alpha3: 'ISL',
    country: 'Iceland',
    num3: '352',
  },
  {
    alpha2: 'IT',
    alpha3: 'ITA',
    country: 'Italy',
    num3: '380',
  },
  {
    alpha2: 'JE',
    alpha3: 'JEY',
    country: 'Jersey',
    num3: '832',
  },
  {
    alpha2: 'JM',
    alpha3: 'JAM',
    country: 'Jamaica',
    num3: '388',
  },
  {
    alpha2: 'JO',
    alpha3: 'JOR',
    country: 'Jordan',
    num3: '400',
  },
  {
    alpha2: 'JP',
    alpha3: 'JPN',
    country: 'Japan',
    num3: '392',
  },
  {
    alpha2: 'KE',
    alpha3: 'KEN',
    country: 'Kenya',
    num3: '404',
  },
  {
    alpha2: 'KG',
    alpha3: 'KGZ',
    country: 'Kyrgyzstan',
    num3: '417',
  },
  {
    alpha2: 'KH',
    alpha3: 'KHM',
    country: 'Cambodia',
    num3: '116',
  },
  {
    alpha2: 'KI',
    alpha3: 'KIR',
    country: 'Kiribati',
    num3: '296',
  },
  {
    alpha2: 'KM',
    alpha3: 'COM',
    country: 'Comoros',
    num3: '174',
  },
  {
    alpha2: 'KN',
    alpha3: 'KNA',
    country: 'Saint Kitts and Nevis',
    num3: '659',
  },
  {
    alpha2: 'KP',
    alpha3: 'PRK',
    country: "Democratic People's Republic of Korea",
    num3: '408',
  },
  {
    alpha2: 'KR',
    alpha3: 'KOR',
    country: 'Republic of Korea',
    num3: '410',
  },
  {
    alpha2: 'KW',
    alpha3: 'KWT',
    country: 'Kuwait',
    num3: '414',
  },
  {
    alpha2: 'KY',
    alpha3: 'CYM',
    country: 'Cayman Islands',
    num3: '136',
  },
  {
    alpha2: 'KZ',
    alpha3: 'KAZ',
    country: 'Kazakhstan',
    num3: '398',
  },
  {
    alpha2: 'LA',
    alpha3: 'LAO',
    country: "Lao People's Democratic Republic",
    num3: '418',
  },
  {
    alpha2: 'LB',
    alpha3: 'LBN',
    country: 'Lebanon',
    num3: '422',
  },
  {
    alpha2: 'LC',
    alpha3: 'LCA',
    country: 'Saint Lucia',
    num3: '662',
  },
  {
    alpha2: 'LI',
    alpha3: 'LIE',
    country: 'Liechtenstein',
    num3: '438',
  },
  {
    alpha2: 'LK',
    alpha3: 'LKA',
    country: 'Sri Lanka',
    num3: '144',
  },
  {
    alpha2: 'LR',
    alpha3: 'LBR',
    country: 'Liberia',
    num3: '430',
  },
  {
    alpha2: 'LS',
    alpha3: 'LSO',
    country: 'Lesotho',
    num3: '426',
  },
  {
    alpha2: 'LT',
    alpha3: 'LTU',
    country: 'Lithuania',
    num3: '440',
  },
  {
    alpha2: 'LU',
    alpha3: 'LUX',
    country: 'Luxembourg',
    num3: '442',
  },
  {
    alpha2: 'LV',
    alpha3: 'LVA',
    country: 'Latvia',
    num3: '428',
  },
  {
    alpha2: 'LY',
    alpha3: 'LBY',
    country: 'Libya',
    num3: '434',
  },
  {
    alpha2: 'MA',
    alpha3: 'MAR',
    country: 'Morocco',
    num3: '504',
  },
  {
    alpha2: 'MC',
    alpha3: 'MCO',
    country: 'Monaco',
    num3: '492',
  },
  {
    alpha2: 'MD',
    alpha3: 'MDA',
    country: 'Republic of Moldova',
    num3: '498',
  },
  {
    alpha2: 'ME',
    alpha3: 'MNE',
    country: 'Montenegro',
    num3: '499',
  },
  {
    alpha2: 'MF',
    alpha3: 'MAF',
    country: 'Saint Martin',
    num3: '663',
  },
  {
    alpha2: 'MG',
    alpha3: 'MDG',
    country: 'Madagascar',
    num3: '450',
  },
  {
    alpha2: 'MH',
    alpha3: 'MHL',
    country: 'Marshall Islands',
    num3: '584',
  },
  {
    alpha2: 'MK',
    alpha3: 'MKD',
    country: 'Macedonia',
    num3: '807',
  },
  {
    alpha2: 'ML',
    alpha3: 'MLI',
    country: 'Mali',
    num3: '466',
  },
  {
    alpha2: 'MM',
    alpha3: 'MMR',
    country: 'Myanmar',
    num3: '104',
  },
  {
    alpha2: 'MN',
    alpha3: 'MNG',
    country: 'Mongolia',
    num3: '496',
  },
  {
    alpha2: 'MO',
    alpha3: 'MAC',
    country: 'Macao',
    num3: '446',
  },
  {
    alpha2: 'MP',
    alpha3: 'MNP',
    country: 'Northern Mariana Islands',
    num3: '580',
  },
  {
    alpha2: 'MQ',
    alpha3: 'MTQ',
    country: 'Martinique',
    num3: '474',
  },
  {
    alpha2: 'MR',
    alpha3: 'MRT',
    country: 'Mauritania',
    num3: '478',
  },
  {
    alpha2: 'MS',
    alpha3: 'MSR',
    country: 'Montserrat',
    num3: '500',
  },
  {
    alpha2: 'MT',
    alpha3: 'MLT',
    country: 'Malta',
    num3: '470',
  },
  {
    alpha2: 'MU',
    alpha3: 'MUS',
    country: 'Mauritius',
    num3: '480',
  },
  {
    alpha2: 'MV',
    alpha3: 'MDV',
    country: 'Maldives',
    num3: '462',
  },
  {
    alpha2: 'MW',
    alpha3: 'MWI',
    country: 'Malawi',
    num3: '454',
  },
  {
    alpha2: 'MX',
    alpha3: 'MEX',
    country: 'Mexico',
    num3: '484',
  },
  {
    alpha2: 'MY',
    alpha3: 'MYS',
    country: 'Malaysia',
    num3: '458',
  },
  {
    alpha2: 'MZ',
    alpha3: 'MOZ',
    country: 'Mozambique',
    num3: '508',
  },
  {
    alpha2: 'NA',
    alpha3: 'NAM',
    country: 'Namibia',
    num3: '516',
  },
  {
    alpha2: 'NC',
    alpha3: 'NCL',
    country: 'New Caledonia',
    num3: '540',
  },
  {
    alpha2: 'NE',
    alpha3: 'NER',
    country: 'Niger',
    num3: '562',
  },
  {
    alpha2: 'NF',
    alpha3: 'NFK',
    country: 'Norfolk Island',
    num3: '574',
  },
  {
    alpha2: 'NG',
    alpha3: 'NGA',
    country: 'Nigeria',
    num3: '566',
  },
  {
    alpha2: 'NI',
    alpha3: 'NIC',
    country: 'Nicaragua',
    num3: '558',
  },
  {
    alpha2: 'NL',
    alpha3: 'NLD',
    country: 'Netherlands',
    num3: '528',
  },
  {
    alpha2: 'NO',
    alpha3: 'NOR',
    country: 'Norway',
    num3: '578',
  },
  {
    alpha2: 'NP',
    alpha3: 'NPL',
    country: 'Nepal',
    num3: '524',
  },
  {
    alpha2: 'NR',
    alpha3: 'NRU',
    country: 'Nauru',
    num3: '520',
  },
  {
    alpha2: 'NU',
    alpha3: 'NIU',
    country: 'Niue',
    num3: '570',
  },
  {
    alpha2: 'NZ',
    alpha3: 'NZL',
    country: 'New Zealand',
    num3: '554',
  },
  {
    alpha2: 'OM',
    alpha3: 'OMN',
    country: 'Oman',
    num3: '512',
  },
  {
    alpha2: 'PA',
    alpha3: 'PAN',
    country: 'Panama',
    num3: '591',
  },
  {
    alpha2: 'PE',
    alpha3: 'PER',
    country: 'Peru',
    num3: '604',
  },
  {
    alpha2: 'PF',
    alpha3: 'PYF',
    country: 'French Polynesia',
    num3: '258',
  },
  {
    alpha2: 'PG',
    alpha3: 'PNG',
    country: 'Papua New Guinea',
    num3: '598',
  },
  {
    alpha2: 'PH',
    alpha3: 'PHL',
    country: 'Philippines',
    num3: '608',
  },
  {
    alpha2: 'PK',
    alpha3: 'PAK',
    country: 'Pakistan',
    num3: '586',
  },
  {
    alpha2: 'PL',
    alpha3: 'POL',
    country: 'Poland',
    num3: '616',
  },
  {
    alpha2: 'PM',
    alpha3: 'SPM',
    country: 'Saint Pierre and Miquelon',
    num3: '666',
  },
  {
    alpha2: 'PN',
    alpha3: 'PCN',
    country: 'Pitcairn',
    num3: '612',
  },
  {
    alpha2: 'PR',
    alpha3: 'PRI',
    country: 'Puerto Rico',
    num3: '630',
  },
  {
    alpha2: 'PS',
    alpha3: 'PSE',
    country: 'State of Palestine',
    num3: '275',
  },
  {
    alpha2: 'PT',
    alpha3: 'PRT',
    country: 'Portugal',
    num3: '620',
  },
  {
    alpha2: 'PW',
    alpha3: 'PLW',
    country: 'Palau',
    num3: '585',
  },
  {
    alpha2: 'PY',
    alpha3: 'PRY',
    country: 'Paraguay',
    num3: '600',
  },
  {
    alpha2: 'QA',
    alpha3: 'QAT',
    country: 'Qatar',
    num3: '634',
  },
  {
    alpha2: 'RE',
    alpha3: 'REU',
    country: 'Réunion',
    num3: '638',
  },
  {
    alpha2: 'RO',
    alpha3: 'ROU',
    country: 'Romania',
    num3: '642',
  },
  {
    alpha2: 'RS',
    alpha3: 'SRB',
    country: 'Serbia',
    num3: '688',
  },
  {
    alpha2: 'RU',
    alpha3: 'RUS',
    country: 'Russian Federation',
    num3: '643',
  },
  {
    alpha2: 'RW',
    alpha3: 'RWA',
    country: 'Rwanda',
    num3: '646',
  },
  {
    alpha2: 'SA',
    alpha3: 'SAU',
    country: 'Saudi Arabia',
    num3: '682',
  },
  {
    alpha2: 'SB',
    alpha3: 'SLB',
    country: 'Solomon Islands',
    num3: '090',
  },
  {
    alpha2: 'SC',
    alpha3: 'SYC',
    country: 'Seychelles',
    num3: '690',
  },
  {
    alpha2: 'SD',
    alpha3: 'SDN',
    country: 'Sudan',
    num3: '729',
  },
  {
    alpha2: 'SE',
    alpha3: 'SWE',
    country: 'Sweden',
    num3: '752',
  },
  {
    alpha2: 'SG',
    alpha3: 'SGP',
    country: 'Singapore',
    num3: '702',
  },
  {
    alpha2: 'SH',
    alpha3: 'SHN',
    country: 'Saint Helena, Ascension and Tristan da Cunha',
    num3: '654',
  },
  {
    alpha2: 'SI',
    alpha3: 'SVN',
    country: 'Slovenia',
    num3: '705',
  },
  {
    alpha2: 'SJ',
    alpha3: 'SJM',
    country: 'Svalbard and Jan Mayen',
    num3: '744',
  },
  {
    alpha2: 'SK',
    alpha3: 'SVK',
    country: 'Slovakia',
    num3: '703',
  },
  {
    alpha2: 'SL',
    alpha3: 'SLE',
    country: 'Sierra Leone',
    num3: '694',
  },
  {
    alpha2: 'SM',
    alpha3: 'SMR',
    country: 'San Marino',
    num3: '674',
  },
  {
    alpha2: 'SN',
    alpha3: 'SEN',
    country: 'Senegal',
    num3: '686',
  },
  {
    alpha2: 'SO',
    alpha3: 'SOM',
    country: 'Somalia',
    num3: '706',
  },
  {
    alpha2: 'SR',
    alpha3: 'SUR',
    country: 'Suriname',
    num3: '740',
  },
  {
    alpha2: 'SS',
    alpha3: 'SSD',
    country: 'South Sudan',
    num3: '728',
  },
  {
    alpha2: 'ST',
    alpha3: 'STP',
    country: 'Sao Tome and Principe',
    num3: '678',
  },
  {
    alpha2: 'SV',
    alpha3: 'SLV',
    country: 'El Salvador',
    num3: '222',
  },
  {
    alpha2: 'SX',
    alpha3: 'SXM',
    country: 'Sint Maarten',
    num3: '534',
  },
  {
    alpha2: 'SY',
    alpha3: 'SYR',
    country: 'Syrian Arab Republic',
    num3: '760',
  },
  {
    alpha2: 'SZ',
    alpha3: 'SWZ',
    country: 'Swaziland',
    num3: '748',
  },
  {
    alpha2: 'TC',
    alpha3: 'TCA',
    country: 'Turks and Caicos Islands',
    num3: '796',
  },
  {
    alpha2: 'TD',
    alpha3: 'TCD',
    country: 'Chad',
    num3: '148',
  },
  {
    alpha2: 'TF',
    alpha3: 'ATF',
    country: 'French Southern Territories',
    num3: '260',
  },
  {
    alpha2: 'TG',
    alpha3: 'TGO',
    country: 'Togo',
    num3: '768',
  },
  {
    alpha2: 'TH',
    alpha3: 'THA',
    country: 'Thailand',
    num3: '764',
  },
  {
    alpha2: 'TJ',
    alpha3: 'TJK',
    country: 'Tajikistan',
    num3: '762',
  },
  {
    alpha2: 'TK',
    alpha3: 'TKL',
    country: 'Tokelau',
    num3: '772',
  },
  {
    alpha2: 'TL',
    alpha3: 'TLS',
    country: 'Timor-Leste',
    num3: '626',
  },
  {
    alpha2: 'TM',
    alpha3: 'TKM',
    country: 'Turkmenistan',
    num3: '795',
  },
  {
    alpha2: 'TN',
    alpha3: 'TUN',
    country: 'Tunisia',
    num3: '788',
  },
  {
    alpha2: 'TO',
    alpha3: 'TON',
    country: 'Tonga',
    num3: '776',
  },
  {
    alpha2: 'TR',
    alpha3: 'TUR',
    country: 'Turkey',
    num3: '792',
  },
  {
    alpha2: 'TT',
    alpha3: 'TTO',
    country: 'Trinidad and Tobago',
    num3: '780',
  },
  {
    alpha2: 'TV',
    alpha3: 'TUV',
    country: 'Tuvalu',
    num3: '798',
  },
  {
    alpha2: 'TW',
    alpha3: 'TWN',
    country: 'Taiwan, Province of China',
    num3: '158',
  },
  {
    alpha2: 'TZ',
    alpha3: 'TZA',
    country: 'United Republic of Tanzania',
    num3: '834',
  },
  {
    alpha2: 'UA',
    alpha3: 'UKR',
    country: 'Ukraine',
    num3: '804',
  },
  {
    alpha2: 'UG',
    alpha3: 'UGA',
    country: 'Uganda',
    num3: '800',
  },
  {
    alpha2: 'UM',
    alpha3: 'UMI',
    country: 'United States Minor Outlying Islands',
    num3: '581',
  },
  {
    alpha2: 'US',
    alpha3: 'USA',
    country: 'United States of America',
    num3: '840',
  },
  {
    alpha2: 'UY',
    alpha3: 'URY',
    country: 'Uruguay',
    num3: '858',
  },
  {
    alpha2: 'UZ',
    alpha3: 'UZB',
    country: 'Uzbekistan',
    num3: '860',
  },
  {
    alpha2: 'VA',
    alpha3: 'VAT',
    country: 'Holy See',
    num3: '336',
  },
  {
    alpha2: 'VC',
    alpha3: 'VCT',
    country: 'Saint Vincent and the Grenadines',
    num3: '670',
  },
  {
    alpha2: 'VE',
    alpha3: 'VEN',
    country: 'Venezuela (Bolivarian Republic of)',
    num3: '862',
  },
  {
    alpha2: 'VG',
    alpha3: 'VGB',
    country: 'Virgin Islands',
    num3: '092',
  },
  {
    alpha2: 'VI',
    alpha3: 'VIR',
    country: 'Virgin Islands of the United States',
    num3: '850',
  },
  {
    alpha2: 'VN',
    alpha3: 'VNM',
    country: 'Viet Nam',
    num3: '704',
  },
  {
    alpha2: 'VU',
    alpha3: 'VUT',
    country: 'Vanuatu',
    num3: '548',
  },
  {
    alpha2: 'WF',
    alpha3: 'WLF',
    country: 'Wallis and Futuna',
    num3: '876',
  },
  {
    alpha2: 'WS',
    alpha3: 'WSM',
    country: 'Samoa',
    num3: '882',
  },
  {
    alpha2: 'YE',
    alpha3: 'YEM',
    country: 'Yemen',
    num3: '887',
  },
  {
    alpha2: 'YT',
    alpha3: 'MYT',
    country: 'Mayotte',
    num3: '175',
  },
  {
    alpha2: 'ZA',
    alpha3: 'ZAF',
    country: 'South Africa',
    num3: '710',
  },
  {
    alpha2: 'ZM',
    alpha3: 'ZMB',
    country: 'Zambia',
    num3: '894',
  },
  {
    alpha2: 'ZW',
    alpha3: 'ZWE',
    country: 'Zimbabwe',
    num3: '716',
  },
].sort((a, b) => ascending(a.country, b.country));
